var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02374 37.0597C6.86608 37.0597 6.70055 36.9808 6.54289 36.9018C6.22757 36.7439 5.98321 36.3414 6.06204 35.9467L6.6217 30.0345H1.04056C0.480869 30.0345 0 29.553 0 28.9926V1.04194C0 0.481505 0.480869 0 1.04056 0H30.9408C31.5005 0 31.9735 0.481505 31.9735 1.04194V28.9926C31.9735 29.553 31.4926 30.0345 30.9408 30.0345H16.9879L7.65437 36.8229C7.49671 36.9807 7.26022 37.0597 7.01585 37.0597H7.02374ZM2.08108 28.0375H7.74112C8.05644 28.0375 8.30079 28.1164 8.45845 28.3532C8.61611 28.59 8.78165 28.8347 8.69493 29.1505L8.21408 33.9418L16.0261 28.2743C16.1838 28.1164 16.4282 28.1164 16.5858 28.1164H29.987V2.08385H2.07324V28.0375H2.08108Z",
    fill: "url(#paint0_linear_403_201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0447 24.0434H7.10298C6.54329 24.0434 6.07031 23.5619 6.07031 23.0094V7.04094C6.07031 6.4805 6.55117 5.99902 7.10298 5.99902H13.0862C13.6459 5.99902 14.1268 6.4805 14.1268 7.04094C14.1268 7.60137 13.6459 8.07498 13.0862 8.07498H8.06474V22.0464H24.0121V8.07498H18.9906C18.4309 8.07498 17.95 7.59348 17.95 7.04094C17.95 6.4884 18.4309 5.99902 18.9906 5.99902H24.9738C25.5335 5.99902 26.0065 6.4805 26.0065 7.04094V23.0094C26.0065 23.5698 25.5256 24.0434 25.0526 24.0434H25.0447Z",
    fill: "url(#paint1_linear_403_201)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0862 12.0691H7.10298C6.54329 12.0691 6.07031 11.5876 6.07031 11.0271C6.07031 10.4667 6.55117 9.9931 7.10298 9.9931H13.0862C13.6459 9.9931 14.1268 10.4746 14.1268 11.0271C14.1268 11.5797 13.5671 12.0691 13.0862 12.0691Z",
    fill: "url(#paint2_linear_403_201)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0451 12.0691H19.062C18.5023 12.0691 18.0293 11.5876 18.0293 11.0271C18.0293 10.4667 18.5102 9.9931 19.062 9.9931H25.0451C25.6048 9.9931 26.0857 10.4746 26.0857 11.0271C26.0857 11.5797 25.526 12.0691 25.0451 12.0691Z",
    fill: "url(#paint3_linear_403_201)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.971 48C22.8133 48 22.6557 47.921 22.4902 47.8421C22.1748 47.6842 21.9305 47.2817 22.0093 46.887L22.569 40.9748H16.9878C16.4281 40.9748 15.9473 40.4933 15.9473 39.9408V29.0794C15.9473 28.519 16.4281 28.0375 16.9878 28.0375C17.5475 28.0375 18.0284 28.519 18.0284 29.0794V39.0567H23.6884C24.0116 39.0567 24.2481 39.1357 24.4057 39.3725C24.5634 39.6093 24.721 39.8539 24.6422 40.1697L24.1613 44.961L31.9734 39.2935C32.1311 39.1357 32.3754 39.1356 32.5331 39.1356H45.9342V13.1031H31.0196C30.4599 13.1031 29.9869 12.6216 29.9869 12.0612C29.9869 11.5007 30.4678 11.0192 31.0196 11.0192H46.9669C47.5266 11.0192 47.9996 11.5007 47.9996 12.0612V40.0118C47.9996 40.5723 47.5187 41.0459 46.9669 41.0459H32.9351L23.6095 47.8342C23.4519 47.9132 23.2075 47.9921 22.971 47.9921V48Z",
    fill: "url(#paint4_linear_403_201)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0608 18.0602H13.0776C12.5179 18.0602 12.0449 17.5787 12.0449 17.0261V7.12775C12.0449 6.56732 12.5258 6.08582 13.0776 6.08582H19.0608C19.6205 6.08582 20.1014 6.56732 20.1014 7.12775V17.105C20.0226 17.5865 19.5417 18.0602 19.0608 18.0602ZM14.0393 16.0631H18.0281V8.07495H14.0393V16.0631Z",
    fill: "url(#paint5_linear_403_201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_201",
    x1: 15.9867,
    y1: 0,
    x2: 15.9867,
    y2: 37.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_201",
    x1: 16.0384,
    y1: 5.99902,
    x2: 16.0384,
    y2: 24.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_201",
    x1: 10.0985,
    y1: 9.9931,
    x2: 10.0985,
    y2: 12.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_201",
    x1: 22.0575,
    y1: 9.9931,
    x2: 22.0575,
    y2: 12.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_201",
    x1: 31.9734,
    y1: 11.0192,
    x2: 31.9734,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_201",
    x1: 16.0732,
    y1: 6.08582,
    x2: 16.0732,
    y2: 18.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon18.b0cd9032cb8ac35f1acac1a0c51d5d21.svg";
export { ForwardRef as ReactComponent };